import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteEmbedRPC } from "./deleteEmbedRPC";

export class DeleteEmbedRPCClientImpl extends DeleteEmbedRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteEmbedRPC.Request): Promise<LeoRPCResult<DeleteEmbedRPC.Response, DeleteEmbedRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "report/DeleteEmbed",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteEmbedRPC.ResponseDTO,
      DeleteEmbedRPC.Errors.ErrorsDTO,
      DeleteEmbedRPC.Response,
      DeleteEmbedRPC.Errors.Errors
    >(
      response,
      "report/DeleteEmbed",
      DeleteEmbedRPC.Response.fromDTO,
      DeleteEmbedRPC.Errors.fromDTO
    );
  }
}
